import React, { Component } from "react";
import axios from "axios";
import "../../App.css";
import Banner from "../../components/Banner";
import { Sidebar } from "../../components/Sidebar";

const API = localStorage.getItem("assethost");


const ACTIVE_STATUS_OPTIONS = [
  { value: "", label: "Select" },
  { value: "YES", label: "Yes" },
  { value: "NO", label: "No" },
];

export default class Reports extends Component {
  state = {
    list: [],
    id: 0,
    name: "",
    sqlText: "",
    titles: "",
    activeStatus: 1,
    reportFilters: [],
    reportSheets: [],
    menus: [],
    menu: "",
    msg: "",
    error: "",
  };
  componentDidMount() {
    this.getList();
  }
  reportAction(id) {
    this.setState({
      id: 0,
      name: "",
      sqlText: "",
      titles: "",
      activeStatus: 1,
      msg: "",
      reportFilters: [],
      reportSheets: [],
    });
    if (id > 0) {
       const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }
      axios
        .get(API   + "/report/getreportbyid/" + id, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(
          (res) => {
            this.setState({
              id: res.data.id,
              name: res.data.name,
              sqlText: res.data.sqlText,
              titles: res.data.titles,
              activeStatus: res.data.activeStatus,
              reportFilters: res.data.reportFilters,
              reportSheets: res.data.reportSheets
            });
          },
          (err) => {
            console.log(".....");
          }
        );
    }
    document.querySelector("#reportAction").style.display = "flex";
  }
  closePopup() {
    document.querySelector("#reportAction").style.display = "none";
    console.log("......close");
  }
  saveReport(e) {
      e.preventDefault();

     const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }
    var data = {
      id: this.state.id,
      name: this.state.name,
      sqlText: this.state.sqlText,
      titles: this.state.titles,
      activeStatus: this.state.activeStatus,
      reportFilters: this.state.reportFilters,
      reportSheets: this.state.reportSheets
    };
    axios
      .post(API   + "/report/reportsave", data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(
        (res) => {
          console.log(res.data);
          this.setState({ msg: res.data });
          this.getList();
          this.closePopup();
          setTimeout(() => {
            this.setState({ msg: "" });
          }, 3000);
        },
        (err) => {
          console.log(".....");
        }
      );
  }
  getList() {
     const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }
    axios
      .get(API  + "/report/getallreports", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(
        (res) => {
          this.setState({ list: res.data });
        },
        (err) => {
          console.log(".....");
        }
      );
  }
  addFilter() {
    let list = this.state.reportFilters.slice();
    list.push({
      id: 0,
      reportFilterType: "",
      parameterMapper: "",
      label1: "",
      label2: "",
      columnName: "",
      selectSql: "",
      selectColumn: "",
      required: 0,
      activeStatus: 1,
    });
    this.setState({ reportFilters: list });
  }
  setRowValue(index, e, name) {
    let list = this.state.reportFilters.slice();
    switch (name) {
      case "columnName":
        list[index].columnName = e.target.value;
        break;
      case "label1":
        list[index].label1 = e.target.value;
        break;
      case "label2":
        list[index].label2 = e.target.value;
        break;
      case "reportFilterType":
        list[index].reportFilterType = e.target.value;
        break;
      case "parameterMapper":
        list[index].parameterMapper = e.target.value;
        break;
      case "selectSql":
        list[index].selectSql = e.target.value;
        break;
      case "selectColumn":
        list[index].selectColumn = e.target.value;
        break;
      case "required":
        list[index].required = e.target.value;
        break;
      case "activeStatus":
        list[index].activeStatus = e.target.value;
        break;
      default:
        console.log("default");
        break;
    }
    this.setState({ reportFilters: list });
  }
  addSheet() {
    let list = this.state.reportSheets.slice();
    list.push({
      id: 0,
      name: "",
      columnName: "",
      sqlText: "",
      title: "",
      activeStatus: 1,
    });
    this.setState({ reportSheets: list });
  }
  setRowValueSheet(index, e, name) {
    let list = this.state.reportSheets.slice();
    switch (name) {
      case "name":
        list[index].name = e.target.value;
        break;
      case "columnName":
        list[index].columnName = e.target.value;
        break;
      case "sqlText":
        list[index].sqlText = e.target.value;
        break;
      case "title":
        list[index].title = e.target.value;
        break;
      case "activeStatus":
        list[index].activeStatus = e.target.value;
        break;
      default:
        console.log("default");
        break;
    }
    this.setState({ reportSheets: list });
  }
  render() {
    let divMsg = null;
    if (this.state.msg) {
      divMsg = <div className="alert alert-success mx-7">{this.state.msg}</div>;
    }

    return (
      <div className="min-h-screen h-dvh flex justify-between bg-white">
        <Sidebar />
        <div className="min-h-screen w-[85%] flex flex-col">
          <Banner title="Manage Reports" withIcons={true} />
          <div className="w-full grow px-5 h-[60%]">
            <div className="flex gap-2 mb-2 items-baseline justify-between">
              <h3 className="font-bold">Configured Reports</h3>
              <button
                className="hover:font-bold flex gap-1 group"
                onClick={() => this.showForm(0)}
              >
                <i
                  className="bi bi-plus-circle group-hover:scale-105"
                  style={{ color: "black" }}
                ></i>
                Add Report
              </button>
            </div>
            {divMsg}
            {this.state.list.length === 0 ? (
              <div className="text-gray-500">No reports found.</div>
            ) : (
              <div className="overflow-x-auto w-full border h-[93%] relative overflow-y-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50 sticky top-0">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        ID
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Name
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Status
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {this.state.list.map((report, index) => (
                      <tr
                        key={`report-row-${report.id}`}
                        className="hover:bg-gray-50"
                      >
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {report.id}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {report.name}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {report.activeStatus}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                          <button
                            className="btn btn-success"
                            onClick={(e) => this.reportAction(report.id)}
                          >
                            Edit
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            <div
              className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
              id="reportAction"
              style={{ display: "none" }}
            >
              <form className="bg-white rounded-lg shadow-xl w-full max-w-6xl max-h-[90vh] overflow-y-auto">
                <div className="bg-primary text-white px-6 py-4 rounded-t-lg">
                  <h3 className="text-lg font-semibold">Report Action</h3>
                </div>
                <div className="p-6">
                  <div className="grid grid-cols-2 gap-6 mb-6">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Name
                      </label>
                      <input
                        type="text"
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={this.state.name}
                        onChange={(e) => {
                          this.setState({ name: e.target.value });
                        }}
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Status
                      </label>
                      <select
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={this.state.activeStatus}
                        onChange={(e) => {
                          this.setState({ activeStatus: e.target.value });
                        }}
                      >
                        {ACTIVE_STATUS_OPTIONS.map((status) => (
                        <option key={status.value} value={status.value}>
                          {status.label}
                        </option>
                      ))}
                      </select>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-6 mb-6">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Titles
                      </label>
                      <textarea
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        rows="3"
                        value={this.state.titles}
                        onChange={(e) => {
                          this.setState({ titles: e.target.value });
                        }}
                      ></textarea>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        SQL
                      </label>
                      <textarea
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        rows="3"
                        value={this.state.sqlText}
                        onChange={(e) => {
                          this.setState({ sqlText: e.target.value });
                        }}
                      ></textarea>
                    </div>
                  </div>

                  {/* Filters Section */}
                  <div className="mb-6">
                    <div className="bg-gray-50 px-4 py-3 border-b border-gray-200 rounded-t-lg">
                      <h4 className="text-lg font-medium text-gray-900">
                        Filters
                      </h4>
                    </div>
                    <div className="p-4 border border-t-0 border-gray-200 rounded-b-lg">
                      <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-gray-200">
                          <thead className="bg-gray-50">
                            <tr>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Column Name
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Label 1
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Label 2
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Filter Type
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Parameter
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Select Sql
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Select Column
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Required
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Status
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Actions
                              </th>
                            </tr>
                          </thead>
                          <tbody className="bg-white divide-y divide-gray-200">
                            {this.state.reportFilters.map(
                              (reportFilter, index) => (
                                <tr key={index}>
                                  <td className="px-6 py-4">
                                    <input
                                      type="text"
                                      className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                                      value={reportFilter.columnName}
                                      onChange={(e) => {
                                        this.setRowValue(
                                          index,
                                          e,
                                          "columnName"
                                        );
                                      }}
                                    />
                                  </td>
                                  <td className="px-6 py-4">
                                    <input
                                      type="text"
                                      className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                                      value={reportFilter.label1}
                                      onChange={(e) => {
                                        this.setRowValue(index, e, "label1");
                                      }}
                                    />
                                  </td>
                                  <td className="px-6 py-4">
                                    <input
                                      type="text"
                                      className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                                      value={reportFilter.label2}
                                      onChange={(e) => {
                                        this.setRowValue(index, e, "label2");
                                      }}
                                    />
                                  </td>
                                  <td className="px-6 py-4">
                                    <select
                                      className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                                      value={reportFilter.reportFilterType}
                                      onChange={(e) => {
                                        this.setRowValue(
                                          index,
                                          e,
                                          "reportFilterType"
                                        );
                                      }}
                                    >
                                      <option value="BOOLEAN">BOOLEAN</option>
                                      <option value="DATE_RANGE">
                                        DATE RANGE
                                      </option>
                                      <option value="NUMERIC">NUMERIC</option>
                                      <option value="SELECT_STATEMENT">
                                        SELECT STATEMENT
                                      </option>
                                      <option value="SINGLE_DATE">
                                        SINGLE DATE
                                      </option>
                                      <option value="STRING_LIKE">
                                        STRING LIKE
                                      </option>
                                    </select>
                                  </td>
                                  <td className="px-6 py-4">
                                    <select
                                      className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                                      value={reportFilter.parameterMapper}
                                      onChange={(e) => {
                                        this.setRowValue(
                                          index,
                                          e,
                                          "parameterMapper"
                                        );
                                      }}
                                    >
                                      <option value="parameter1">
                                        Parameter 1
                                      </option>
                                      <option value="parameter2">
                                        Parameter 2
                                      </option>
                                      <option value="parameter3">
                                        Parameter 3
                                      </option>
                                      <option value="parameter4">
                                        Parameter 4
                                      </option>
                                      <option value="parameter5">
                                        Parameter 5
                                      </option>
                                      <option value="parameter6">
                                        Parameter 6
                                      </option>
                                    </select>
                                  </td>
                                  <td className="px-6 py-4">
                                    <input
                                      type="text"
                                      className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                                      value={reportFilter.selectSql}
                                      onChange={(e) => {
                                        this.setRowValue(index, e, "selectSql");
                                      }}
                                    />
                                  </td>
                                  <td className="px-6 py-4">
                                    <input
                                      type="text"
                                      className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                                      value={reportFilter.selectColumn}
                                      onChange={(e) => {
                                        this.setRowValue(
                                          index,
                                          e,
                                          "selectColumn"
                                        );
                                      }}
                                    />
                                  </td>
                                  <td className="px-6 py-4">
                                    <select
                                      className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                                      value={reportFilter.required}
                                      onChange={(e) => {
                                        this.setRowValue(index, e, "required");
                                      }}
                                    >
                                      <option value="1">Yes</option>
                                      <option value="0">No</option>
                                    </select>
                                  </td>
                                  <td className="px-6 py-4">
                                    <select
                                      className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                                      value={reportFilter.activeStatus}
                                      onChange={(e) => {
                                        this.setRowValue(
                                          index,
                                          e,
                                          "activeStatus"
                                        );
                                      }}
                                    >
                                      {ACTIVE_STATUS_OPTIONS.map((status) => (
                        <option key={status.value} value={status.value}>
                          {status.label}
                        </option>
                      ))}
                                    </select>
                                  </td>
                                </tr>
                              )
                            )}
                            <tr>
                              <td colSpan="9" className="px-6 py-4 text-center">
                                <button
                                  className="btn btn-success"
                                  onClick={() => {
                                    this.addFilter();
                                  }}
                                >
                                  Insert Filter
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  {/* Sheets Section */}
                  <div className="mb-6">
                    <div className="bg-gray-50 px-4 py-3 border-b border-gray-200 rounded-t-lg">
                      <h4 className="text-lg font-medium text-gray-900">
                        Sheets
                      </h4>
                    </div>
                    <div className="p-4 border border-t-0 border-gray-200 rounded-b-lg">
                      <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-gray-200">
                          <thead className="bg-gray-50">
                            <tr>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Name
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Column
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                SQL
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Title
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Status
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Actions
                              </th>
                            </tr>
                          </thead>
                          <tbody className="bg-white divide-y divide-gray-200">
                            {this.state.reportSheets.map((item, index) => (
                              <tr key={index}>
                                <td className="px-6 py-4">
                                  <input
                                    type="text"
                                    className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                                    value={item.name}
                                    onChange={(e) => {
                                      this.setRowValueSheet(index, e, "name");
                                    }}
                                  />
                                </td>
                                <td className="px-6 py-4">
                                  <input
                                    type="text"
                                    className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                                    value={item.columnName}
                                    onChange={(e) => {
                                      this.setRowValueSheet(
                                        index,
                                        e,
                                        "columnName"
                                      );
                                    }}
                                  />
                                </td>
                                <td className="px-6 py-4">
                                  <textarea
                                    className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                                    value={item.sqlText}
                                    onChange={(e) => {
                                      this.setRowValueSheet(
                                        index,
                                        e,
                                        "sqlText"
                                      );
                                    }}
                                  ></textarea>
                                </td>
                                <td className="px-6 py-4">
                                  <input
                                    type="text"
                                    className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                                    value={item.title}
                                    onChange={(e) => {
                                      this.setRowValueSheet(index, e, "title");
                                    }}
                                  />
                                </td>
                                <td className="px-6 py-4">
                                  <select
                                    className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                                    value={item.activeStatus}
                                    onChange={(e) => {
                                      this.setRowValueSheet(
                                        index,
                                        e,
                                        "activeStatus"
                                      );
                                    }}
                                  >
                                     {ACTIVE_STATUS_OPTIONS.map((status) => (
                        <option key={status.value} value={status.value}>
                          {status.label}
                        </option>
                      ))}
                    </select>
                                </td>
                              </tr>
                            ))}
                            <tr>
                              <td colSpan="5" className="px-6 py-4 text-center">
                                <button
                                  className="btn btn-success"
                                  onClick={() => {
                                    this.addSheet();
                                  }}
                                >
                                  Insert Sheet
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  {/* Action Buttons */}
                  <div className="flex justify-center gap-4 pt-4">
                    <button
                      className="btn btn-success px-6 py-2"
                      style={{ backgroundColor: "#36BEEE", color: "#FFF" }}
                      onClick={(e) => this.saveReport(e)}
                    >
                      Save
                    </button>
                    <button
                      className="btn btn-secondary px-6 py-2"
                      onClick={() => this.closePopup()}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
